import CategoryService from "../../services/CategoryService";

export default {
  namespaced: true,
  state() {
    return {
      rootCategories: [],
      partsTags: [],
    };
  },
  mutations: {
    setRootCategories: (state, rootCategories) =>
      (state.rootCategories = rootCategories),
    setPartsTags: (state, partsTags) => (state.partsTags = partsTags),
  },
  actions: {
    getRootCategories: async ({ commit }) => {
      try {
        const rootCategoriesRes = await CategoryService.getRootCategories();
        const rootCategories = rootCategoriesRes.data.reduce((catList, cat) => {
          catList.push({
            id: cat.rootCategoryId,
            title: cat.rootCategoryName,
            description: cat.description,
            image: cat.image,
            path: `${cat.slug}`,
            metaTitle: cat.metaTitle,
            metaDescription: cat.metaDescription,
            subCategories: cat.Categories || [],
          });
          return catList;
        }, []);
        commit("setRootCategories", rootCategories);
      } catch (err) {
        console.log(err);
      }
    },
    getCategories: async (context, { rootCategory }) =>
      await CategoryService.getCategories({ rootCategory }),
    getPartsTags: async ({ commit }, { rootCategory, category }) => {
      try {
        const partsTags = await CategoryService.getPartsTags({
          rootCategory,
          category,
        });
        commit("setPartsTags", partsTags.data);
      } catch (err) {
        commit("setPartsTags", []);
        console.log(err);
      }
    },
  },
  getters: {
    getRootCategories: (state) => state.rootCategories,
    getPartsTags: (state) => state.partsTags,
  },
};
